import { useGetCachedShiftRouteEstimate } from "@src/appV2/redesign/ArrivalTime/ShiftRouteEstimate/useShiftRouteEstimate";
import { useArrivalTimePoints } from "@src/appV2/redesign/ArrivalTime/useArrivalTimePoints";
import { ArrivalTimeBottomSheet } from "@src/appV2/redesign/Shift/BookingConfirmationBottomSheet/ArrivalTime/Sheet";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { parseISO } from "date-fns";

import { useArrivalTimeConfig } from "../../../ArrivalTime/useArrivalTimeConfig";
import { type ShiftInvite } from "../types";

interface ShiftInviteArrivalTimeBottomSheetContainerProps {
  modalState: UseModalState;
  shiftInvite: ShiftInvite;
  onConfirm: () => Promise<void>;
}

export function ShiftInviteArrivalTimeBottomSheetContainer(
  props: ShiftInviteArrivalTimeBottomSheetContainerProps
) {
  const { modalState, shiftInvite, onConfirm } = props;
  const worker = useDefinedWorker();

  const shiftStartIso = shiftInvite.attributes.shiftDetails.start;
  const shiftStart = parseISO(shiftStartIso);

  const { data: arrivalTimePoints, isLoading: isLoadingPoints } = useArrivalTimePoints({
    workerId: worker.userId,
    qualification: shiftInvite.attributes.shiftDetails.agentReq,
  });
  const { latePointsDeduction, onTimePointsReward } = arrivalTimePoints ?? {};

  // This should be present from the shift invite page
  const computedArrivalData = useGetCachedShiftRouteEstimate(shiftInvite.id);

  const { gracePeriodInMinutesForDriveETA } = useArrivalTimeConfig();

  const targetArrivalTime = computedArrivalData?.targetArrivalTime;
  const departureTime = computedArrivalData?.departureTime;

  return (
    <ArrivalTimeBottomSheet
      modalState={modalState}
      targetDatetime={targetArrivalTime ?? shiftStart}
      workplaceTimezone={shiftInvite.attributes.facility.tmz ?? "America/Los_Angeles"}
      departureDatetime={departureTime ?? shiftStart}
      shiftStartDate={shiftStart}
      gracePeriodInMinutesForDriveETA={gracePeriodInMinutesForDriveETA}
      latePointsDeduction={latePointsDeduction}
      isLoadingPoints={isLoadingPoints}
      isLoadingEta={false}
      isLoadingBooking={false}
      onTimePointsReward={onTimePointsReward}
      onConfirm={async () => {
        await onConfirm();
      }}
    />
  );
}
